// jquery on ready
jQuery(function($) {
    // on scroll add header class
    $(window).scroll(function() {
        if($('#job-board-page-wrapper') && $('#job-board-page-wrapper')[0].classList.contains('mobile') && $('#job-board-page-wrapper')[0].classList.contains('job-open')) {
            // get the height of the header
            var headerHeight = $('.job-board__details__header').outerHeight();

            if ($(this).scrollTop() > headerHeight + 100) {
                if(!$('.job-board__details__header').hasClass('collapsed')) {
                    $('.job-board__details__body').css('padding-top', headerHeight + 34 + 'px');
                    $('.job-board__details__header').addClass("collapsed");
                    var headerHeight = $('.job-board__details__header').outerHeight();
                    $('.job-board__details__header').css('top', '0px');
                }
            } else {
                if($('.job-board__details__header').hasClass('collapsed')) {
                    $('.job-board__details__body').css('padding-top', '34px');
                    $('.job-board__details__header').removeClass("collapsed");
                    $('.job-board__details__header').css('top', '0');
                }
            }
        }
    });
});